import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";

const tableURLMapping = {
  drmBidTableData: URLS.DRM_DELETE_DETAILS,
};
export const drmDeleteTableData = async ([
  deleteData,
  tableName,
  controller,
]) => {
  const response = await axios.post(
    `${tableURLMapping[tableName]}`,
    { deleteData },
   { signal: controller.signal }
  );

  if (response.status >= 400) {
    throw new Error(response.message);
  }
  return response;
};
